/** @jsxImportSource @emotion/react */
import * as s from './style';
import React from 'react';
import MapPopupFrame from './MapPopupFrame';

const HousingPopup = ({ selectedLocation, onClickPopDetailButton , handlePopupClose}) => {
    const rows = [
        {
            label: '주택수',
            value: `${selectedLocation?.stock?.toLocaleString() || 0}호`,
        },
        {
            label: '전월세 거래비율',
            value: `${selectedLocation?.trdeDeal || 0}%`,
        },
        {
            label: '매매가',
            value: `${selectedLocation?.trd?.toLocaleString() || 0}만원`,
        },
        {
            label: '전출 전월세가(환산보증금)',
            value: `${selectedLocation?.deposit?.toLocaleString() || 0}만원`,
        },
    ];

    return (
        <MapPopupFrame
            popupId="housing_popup"
            isVisible={true}
            title={selectedLocation ? `${selectedLocation.hjdNm} 현황` : ''}
            onClose={handlePopupClose}
            containerCss={s.mapContainer}
            footer={
                <div className="map-popup-buttons">
                    <button
                        id="populationDetailBtn"
                        className="map-secondary-button"
                        onClick={onClickPopDetailButton}
                    >
                        주택현황 상세조회
                    </button>
                </div>
            }
        >
            {rows.map((row) => (
                <div className="map-popup-item" key={row.label}>
                    <span className="map-popup-label">{row.label} : </span>
                    <span className="map-popup-value">{row.value}</span>
                </div>
            ))}
        </MapPopupFrame>
    );
};

export default HousingPopup;
